import React from 'react'
import { Link } from 'react-router-dom'

export default function NavItem({ href, isActive, children, anchor, ...props }) {
    return (
        <li>
            {anchor ? (
                <a href={props.to} className={isActive ? 'nav-item-link active' : 'nav-item-link'}>
                    {children}
                </a>
            ) : (
                <Link to={href} className={isActive ? 'nav-item-link active' : 'nav-item-link'}>
                    {children}
                </Link>
            )}
        </li>
    )
}
